import React from 'react';
import { Grid } from 'semantic-ui-react';
import './styles.less';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { FormInputField } from '../../../../../semantic-ui/components/form-input-field';
import { FormSelectField } from '../../../../../semantic-ui/components/form-select-field';
import { CustomRequiredComponent } from '../../../../../semantic-ui/components/custom-required';
import { normalizeNumber } from '../../../../../utils/normalizeNumber';

export const OrdersWaysFormView = ({ optionsList, isOptionsListLoading }) => {
	return (
		<Grid className="orders-ways-form">
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Группа заказов
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="orders-ways-form__column">
					<Field
						name="group_id"
						type="text"
						component={FormSelectField}
						autoComplete="off"
						options={optionsList.group}
						loading={isOptionsListLoading.carriers}
						placeholder="Выберите группу заказов"
						isWithoutSelectOnBlur
						search
						disabled={isOptionsListLoading.carriers}
						dropdownClassName="static"
						noResultsMessage="Группа заказов не найдена"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Название
					<CustomRequiredComponent />
				</Grid.Column>
				<Grid.Column width={8} className="orders-ways-form__column">
					<Field
						name="name"
						type="text"
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите название"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Грузоподъемность авто
				</Grid.Column>

				<Grid.Column width={4} className="orders-ways-form__column" style={{ maxWidth: 200 }}>
					<Field
						name="weight"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						placeholder="Укажите массу"
						unit="кг"
					/>
				</Grid.Column>

				<div className="orders-ways-form__column utility-column">Коэфф. утилизации</div>

				<Grid.Column width={3} className="orders-ways-form__column">
					<Field
						name="weight_recycling_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						placeholder="Укажите коэфф."
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Объем кузова авто
				</Grid.Column>

				<Grid.Column width={4} className="orders-ways-form__column" style={{ maxWidth: 200 }}>
					<Field
						name="volume"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						placeholder="Укажите объем"
						unit="м³"
					/>
				</Grid.Column>

				<div className="orders-ways-form__column utility-column">Коэфф. утилизации</div>

				<Grid.Column width={3} className="orders-ways-form__column">
					<Field
						name="volume_recycling_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						placeholder="Укажите коэфф."
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Коэффициент массы груза
				</Grid.Column>
				<Grid.Column width={8} className="orders-ways-form__column">
					<Field
						name="weight_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите коэффициент массы груза"
					/>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row className="orders-ways-form__row">
				<Grid.Column width={6} className="orders-ways-form__column">
					Коэффициент объема груза
				</Grid.Column>
				<Grid.Column width={8} className="orders-ways-form__column">
					<Field
						name="volume_rate"
						type="text"
						normalize={normalizeNumber}
						component={FormInputField}
						autoComplete="off"
						placeholder="Укажите коэффициент объема груза"
					/>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

OrdersWaysFormView.propTypes = {
	optionsList: PropTypes.objectOf(
		PropTypes.arrayOf(
			PropTypes.shape({
				text: PropTypes.string.isRequired,
				value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
				key: PropTypes.string.isRequired,
			}),
		),
	),
	isOptionsListLoading: PropTypes.objectOf(PropTypes.bool.isRequired).isRequired,
};
